import React from "react";
import ModulesList from "./components/ModulesList";

const Modules: React.FC = () => {
  return (
    <>
      <ModulesList />
    </>
  );
};

export default Modules;
